import { createRouter, createWebHistory } from "vue-router";
import PrimaryRoutes from "./primary.js";
import IdentityRoutes from "./identity.js";
import NftRoutes from "./nft.js";

import UseBeforeEach from "@/composables/router/useBeforeEach";

const {
  handleSuccessModal,
  handleIdentityKycPathings,
  resetLoadingButtonState,
} = UseBeforeEach();
const allRoutes = [...PrimaryRoutes, ...IdentityRoutes, ...NftRoutes];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: allRoutes,
});

router.beforeEach((to, from, next) => {
  handleSuccessModal(to, from, next);
  handleIdentityKycPathings(to, from, next);
  resetLoadingButtonState(to, from, next);
});

export default router;
